import styled from 'styled-components';

const Wrapper = styled.div`
	background-color: #29292C;
	height: calc(100vh - 40px);
	width: 100%;
	.video-react.video-react-fluid {
		height: calc(100vh - 40px);
	}
	.render-container {
		position: absolute;
	}
	.player {
		position: absolute;
	}
	.pc-monitor {
		height: 450px !important;
		position:absolute;
		top: 37%;
	}
	.exc-btn {
		font-size: 21px;
		max-width: 500px;
		width: 150px;
    	height: 150px;
		margin-bottom: 1rem;
		border-radius: 100px;
		/* font-weight: unset !important; */
		white-space: unset;
		box-shadow: 0px 0px 60px 30px #0F1550;
		animation-name: rotate;
		animation-delay: 3s;
		animation-duration: 6s;
		letter-spacing: 0.7px;
		line-height: normal;
	}
	.footer-text {
		display: flex;
		justify-content: center;
		color: #A8A8B1;
	}
	
	@keyframes rotate{
		from {
			box-shadow: 0px 0px 20px 10px #0F1550;
		}
		to {
			box-shadow: 0px 0px 60px 30px #0F1550;
			opacity: 1;
		}
	}

	.footer-container {
		position: fixed;
		width: 100%;
		bottom: 3%;
		animation: keyName 5s;
		animation-delay: 2.5s;
	.footer-button {
		display: flex;
		justify-content: center;
		margin-top: 120px;
		bottom: 10rem;
		text-shadow:0px 0px 20px #fff,0px 0px 20px #614ad3;
		animation-name:glow 5s;
		animation-delay: 2.5s;
	}
	.footer-content {
			margin-top: 3%;
			.footer-text {
				display: flex;
				justify-content: center;
				color: #A8A8B1;
				a {
					color: #3A4FFF;
				}
			}
		}
	}
	@keyframes keyName {
		0% { opacity:0; transform:scale(0.80);}
		100% { opacity:1; transform:scale(1)}
	}
	.main-panel {
		/* height: 562px; */
		position: fixed;
		/* margin-bottom: 85px; */
		display: block;
		width: 100%;
		z-index: 1;
		background-color: black;
		.pc-monitor {
			height: 350px;
			// position: absolute;
			// bottom: -78px;
			// left: 30%;
			// margin-left: -295px;
		}
		.main-panel-container {
			// position: absolute;
			// left: 50%;
			// top: 0;
			// width: 50%;
			// height: 100%;
			animation: keyName 6s;
			animation-delay: 2.5s;
			/* position: relative; */
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			.pc-monitor {
				/* position: absolute; */
				/* top: 90%; */
				/* height: 580px; */
			}
			.headerText {
				font-weight: 700;
				font-size: 50px;
    			letter-spacing: 2px;
				margin-top: 3rem;
				margin-bottom: 0.25rem;
				color: #FFFFFF;
				font-family: HaasGrotDisp;
			}
			h1 {
				font-size: 18px;
				color: #A8A8B1;
			}
			h3 {

			}
			p {
				text-align: center;
				margin-bottom: 24px;
			}
		}
		&.exchange {
			.pc-monitor {
				height: 350px;
				position: absolute;
				bottom: -78px;
				left: 50%;
				margin-left: -370px;
			}
			.exc-btn {
				display: flex;
				> * {
					margin: 0 5px;
				}
			}
			.exchange-info {
				position: absolute;
				left: 50px;
				top: 64px;
				h2 {
					font-weight: bold;
				}
				.exchange-logo {
					height: 110px;
				}

				h3 {
					font-size: 35px;
					font-weight: bold;
					margin-bottom: 0;
				}
				.url {
					font-size: 30px;
					color: #808083;
				}
			}
			.main-panel-container {
				position: absolute;
				left: 65%;
				top: 0;
				width: 35%;
				height: 100%;
				display: flex;
				text-align: left;
				align-items: flex-start;
				justify-content: center;
				flex-direction: column;
				h3 {
					font-weight: bold;
				}
				p {
					margin-bottom: 0;
				}
				.exc-btn {
					margin-top: 24px;
				}
			}
		}
	}
	.main-panel::after {
		background-repeat: no-repeat, no-repeat;
		background-position: left -18vw top,right -55vw bottom -20vh;
		background-size: 1300px, cover;
		content: "";
		opacity: 0.09;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		position: absolute;
		z-index: -1;
	}
	.expired {
		color: #FF0000;
	}
	.main-card {
		border-top: 1px solid #000;
		margin: 24px;
		h3 {
			font-weight: bold;
			line-height: 2;
			a {
				padding-left: 8px;
				font-size: 12px;
				font-weight: normal;
			}
		}
		.list-container {
			display: flex;
		}
		.ant-table-thead > tr > th,
		.ant-table-tbody > tr > td {
			padding: 3px 16px;
		}
		.empty-card {
			display: flex;
			align-items: center;
			padding-bottom: 24px;
			i,
			span {
				padding-left: 12px;
			}
		}
	}
	.git-anchor{
		margin-left :3px;
	}
	@media (max-width: 1200px) {
		.pc-monitor {
			/* display: none; */
		}
		.main-panel {
			.main-panel-container {
				position: static;
				width: 100%;
			}
			&.exchange {
				.main-panel-container {
					position: static;
					width: 100%;

					height: auto;
				}
				.exchange-info {
					position: static;
					width: 100%;
					.exchange-logo {
						height: 80px;
					}
					h3 {
						font-size: 24px;
					}
					.url {
						font-size: 12px;
					}
				}
			}
		}
	}
	@media (max-width: 960px) {
		.main-panel {
			padding-left: 12px;
			padding-right: 12px;
			padding-top: 24px;

			.main-panel-container {
				position: static;
				width: 100%;
			}
		}
		.main-card {
			.ant-table-wrapper {
				overflow-x: auto;
			}
		}
	}
	@media (min-width: 1600px) {
		.footer-content {
			margin-top: 4%;
		}
	}
	@media (min-width: 1600px) {
		.footer-content {
			margin-top: 4%;
		}
	}
	@media (min-width: 1025px) and (max-width: 1440px) {
        .headerText {
            font-size: 38px !important;
            margin-top: 2rem !important;
        }
    }
    @media (min-width: 873px) and (max-width: 1024px) {
        .headerText {
            font-size: 38px !important;
            margin-top: 1.5rem !important;
        }
    }
    @media (min-width: 768px) and (max-width: 872px) {
        .headerText {
            font-size: 30px !important;
            margin-top: 0rem !important;
        }
    }
`;

export default Wrapper;
